import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <path
      key='0'
      d='M18,8h-1V6c0-2.8-2.2-5-5-5C9.4,1,7.3,3,7,5.5h1.9C9.2,4,10.4,2.9,12,2.9c1.7,0,3.1,1.4,3.1,3.1v2H6c-1.1,0-2,0.9-2,2v10 c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V10C20,8.9,19.1,8,18,8z M12,17c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.1,17,12,17z'
    />,
  ],
  'LockOpenRounded'
);

const LockOpenRoundedIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(LockOpenRoundedIcon);
